import { paper as PaperJS } from 'paper';
import { isEmpty } from 'validator';
import { getSelectedProduct } from './tagWizardSelector';
import { isInGodMode } from '../_utils';

export const generatePreviewSequence = (
    start,
    count,
    step,
    leadingZeros,
    prefix,
    suffix
) => {
    let aux = [];
    let max = 20;

    const countIsHigher = count > max;
    max = countIsHigher ? max : count;
    for (let i = 0; i < max; i++) {
        aux.push(
            (
                prefix +
                pad(start + step * i, leadingZeros.length) +
                suffix
            ).toString()
        );
    }

    if (countIsHigher) {
        aux.pop();

        aux.push(
            (
                prefix +
                pad(start + step * (count - 1), leadingZeros.length) +
                suffix
            ).toString()
        );
    }
    return aux;
};
export const generatePreviewSequenceForReview = (
    start,
    count,
    step,
    leadingZeros,
    prefix,
    suffix
) => {
    let value = '';

    value += prefix + pad(start + step * 0, leadingZeros.length) + suffix;

    if (count - 1 > 0) {
        value += ' - ';
        value +=
            prefix +
            pad(start + step * (count - 1), leadingZeros.length) +
            suffix;
    }

    return value;
};
export const pad = (number, size) => {
    let aux = String(number);

    while (aux.length < size) {
        aux = '0' + aux;
    }

    return aux;
};

// EDITOR
export const checkIfActiveColourIsBlack = (colour) => {
    return colour === 'black';
};
export const getLayerErrorMessage = (target, value) => {
    if (!value) return false;
    switch (target) {
        case 'intersection': {
            return 'This layer is intersecting another. Please, reposition it.';
        }
        case 'barcode': {
            return "The content doesn't match the barcode requirements";
        }
    }
    return 'There is a problem with your layer.';
};
export const getLayerErrors = (layer, options) => {
    const { errors: layerErrors, sequenceCount, activeType } = layer;

    const { highestSequence } = options;
    let errors = layerErrors ? Object.values(layerErrors) : [];
    switch (activeType) {
        case 'sequence': {
            if (highestSequence > sequenceCount) {
                errors.push({
                    message: `Sequence size is less than the minimum value. ${sequenceCount}/${highestSequence}`,
                });
            } else if (highestSequence < sequenceCount) {
                errors.push({
                    message: `Sequence size is higher than the minimum value. ${sequenceCount}/${highestSequence}`,
                });
            }
            break;
        }
        case 'list': {
            if (highestSequence > sequenceCount) {
                errors.push({
                    message: `Custom List size is less than the minimum value. ${sequenceCount}/${highestSequence}`,
                });
            } else if (highestSequence < sequenceCount) {
                errors.push({
                    message: `Custom List size is higher than the maximum value. ${sequenceCount}/${highestSequence}`,
                });
            }
            break;
        }
        case 'code': {
            if (layer.types.code.fields?.useList) {
                if (highestSequence > sequenceCount) {
                    errors.push({
                        message: `Sequence size is less than the minimum value. ${sequenceCount}/${highestSequence}`,
                    });
                } else if (highestSequence < sequenceCount) {
                    errors.push({
                        message: `Sequence size is higher than the minimum value. ${sequenceCount}/${highestSequence}`,
                    });
                }
            }
            break;
        }
    }
    return errors.length > 0 ? errors : false;
};
export const getHighestSequence = (layers) => {
    let count = 1;
    layers.map((layer) => {
        const { sequenceCount } = layer;
        count = sequenceCount > count ? sequenceCount : count;
    });
    return count;
};
export const getActiveColour = (colours, selected) => {
    return colours ? colours[selected] : '';
};

/**
 * Check if the given params are part of foil custom
 *
 * @param style
 * @param printingMethod
 * @returns {boolean}
 */
export const isFoilCustom = (styleName, printingMethod) => {
    if (
        isFoil(printingMethod) &&
        styleName &&
        styleName.toLowerCase() == 'custom'
    ) {
        return true;
    }

    return false;
};

/**
 * Check if the given params is foil
 *
 * @param printingMethod
 * @returns {boolean}
 */
export const isFoil = (printingMethod = '') => {
    return printingMethod && printingMethod.toLowerCase() == 'foil';
};

/**
 * A helper function to modify tag data without affecting printing
 *
 * @param tagData
 * @param editor
 * @param tagWizard
 * @returns {*}
 */
export const getTagDataForEditor = (tagData, editor, tagWizard) => {
    // We don't need to run this on print
    const { printingMethod = null, tagType = '' } = tagWizard.userInput;

    if (tagData.tagData.sides) {
        let sides = JSON.parse(JSON.stringify(tagData.tagData.sides));

        tagData.tagData.sides = Object.entries(sides).reduce(
            (newSides, [sideID, side]) => {
                const newSide = {
                    ...side,
                    regions: side.regions
                        ? Object.entries(side.regions).reduce(
                              (newRegions, [regionID, region]) => {
                                  const newRegion = {
                                      ...region,
                                      styles: region.styles
                                          ? Object.entries(
                                                region.styles
                                            ).reduce(
                                                (
                                                    newStyles,
                                                    [styleID, style]
                                                ) => {
                                                    if (
                                                        tagType === 'editor' &&
                                                        isFoilCustom(
                                                            style.name,
                                                            printingMethod
                                                        )
                                                    ) {
                                                        return newStyles;
                                                    }

                                                    return {
                                                        ...newStyles,
                                                        [styleID]: style,
                                                    };
                                                },
                                                {}
                                            )
                                          : false,
                                  };

                                  return {
                                      ...newRegions,
                                      [regionID]: newRegion,
                                  };
                              },
                              {}
                          )
                        : false,
                };

                return {
                    ...newSides,
                    [sideID]: newSide,
                };
            },
            {}
        );
    }

    return tagData;
};

export const getTagData = (editor, tagWizard) => {
    const {
        // minOrder,
        activeLayer,
        group,
        batchCount,
        variationImages,
        itemIncluded,
        revealBackSide,
        // revealBackSideBool,
        sides,
        regions,
        styles,
        layers,
        printingOffset = {},
    } = editor;
    const { cartQty } = tagWizard.userInput;
    const product = getSelectedProduct(tagWizard);
    const minOrder = product.MinOrderQuantity;

    let theActiveLayer = false;
    let visibleLayers = [];
    let tagData = {
        printingOffset: printingOffset,
        batchCount: batchCount,
        revealBackSide: revealBackSide,
        // revealBackSideBool: revealBackSideBool,
        variationImages: variationImages,
        itemIncluded: itemIncluded,
        group: group,
        sides: sides
            ? Object.values(sides).reduce((newSides, side) => {
                  const newSide = {
                      ...side,
                      regions: side.regions
                          ? side.regions.reduce((newRegions, region) => {
                                const { activeStyle } = regions[region];
                                const newRegion = {
                                    ...regions[region],
                                    styles: regions[region].styles
                                        ? regions[region].styles.reduce(
                                              (newStyles, style) => {
                                                  const newStyle = {
                                                      ...styles[style],
                                                      layers: styles[style]
                                                          .layers
                                                          ? styles[
                                                                style
                                                            ].layers.reduce(
                                                                (
                                                                    newLayers,
                                                                    layer
                                                                ) => {
                                                                    const newLayer = {
                                                                        ...getLayerExtendedData(
                                                                            layers[
                                                                                layer
                                                                            ],
                                                                            cartQty
                                                                        ),
                                                                    };
                                                                    
                                                                    if (
                                                                        newLayer
                                                                            .types
                                                                            .code
                                                                    ) {
                                                                        newLayer
                                                                            .types
                                                                            .code
                                                                            .fields
                                                                            .useList
                                                                            ? newLayer
                                                                                  .types
                                                                                  .code
                                                                                  .fields
                                                                                  .useList
                                                                            : false;
                                                                    }
                                                                    const {
                                                                        activeType,
                                                                    } = newLayer;
                                                                    // save the visible layers
                                                                    if (
                                                                        side.active &&
                                                                        regions[
                                                                            region
                                                                        ]
                                                                            .active &&
                                                                        style ===
                                                                            activeStyle
                                                                    ) {
                                                                        visibleLayers.push(
                                                                            newLayer
                                                                        );
                                                                    }
                                                                    // save the active layer
                                                                    if (
                                                                        layer ===
                                                                        activeLayer
                                                                    ) {
                                                                        theActiveLayer = newLayer;
                                                                    }
                                                                    return {
                                                                        ...newLayers,
                                                                        [layer]: newLayer,
                                                                    };
                                                                },
                                                                {}
                                                            )
                                                          : false,
                                                  };
                                                  return {
                                                      ...newStyles,
                                                      [style]: newStyle,
                                                  };
                                              },
                                              {}
                                          )
                                        : false,
                                };
                                return {
                                    ...newRegions,
                                    [region]: newRegion,
                                };
                            }, {})
                          : false,
                  };
                  return {
                      ...newSides,
                      [side.id]: newSide,
                  };
              }, {})
            : false,
    };

    const highestSequence = cartQty;
    const errorLayers = visibleLayers.reduce((aux, layer) => {
        const errors = getLayerErrors(layer, {
            highestSequence: Math.max(highestSequence, minOrder),
        });
        if (errors) {
            aux.push({
                ...layer,
                errors: errors,
            });
        }
        return aux;
    }, []);

    // extend activeLayer with errors
    if (theActiveLayer) {
        theActiveLayer = {
            ...theActiveLayer,
            errors: getLayerErrors(theActiveLayer, {
                highestSequence: Math.max(highestSequence, minOrder),
            }),
        };
    }
    return {
        tagData: tagData,
        highestSequence: highestSequence,
        visibleLayers: visibleLayers,
        errorLayers: errorLayers,
        activeLayer: theActiveLayer,
    };
};
export const getNLISCustomLayers = (layers) => {
    let list = {};

    if (!layers) {
        return {};
    }

    Object.entries(layers).forEach(([key, value]) => {
        const extraSettings =
            typeof value.extraSettings != 'undefined'
                ? value.extraSettings
                : false;
        if (
            extraSettings &&
            typeof extraSettings.showOnNLIS != 'undefined' &&
            extraSettings.showOnNLIS === true
        ) {
            list[key] = { ...value };
        }
    });

    return list;
};
export const getCurve = (layer) => {
    return isBarcode(layer) || isImage(layer) ? false : layer.curve || false;
};
export const getPreset = (layer) => {
    const { activeType, types } = layer;
    const { preset } = types[activeType];

    return preset || {};
};

export const getLayerExtendedData = (layer, cartQty) => {
    if (!layer) return false;
    const { activeType, types, barcode = '' } = layer;
    let layerData = {
        ...layer,
    };
    const count = cartQty;

    switch (activeType) {
        case 'initialvalues': {
            const { content } = types[activeType].fields;
            layerData = {
                ...layerData,
                curve: getCurve(layer),
                previewText: content,
                previewTextReview: content,
            };
            break;
        }
        case 'text': {
            const { content } = types[activeType].fields;
            console.log('content=============', content);
            console.log('layer===================', layer);
            layerData = {
                ...layerData,
                curve: getCurve(layer),
                previewText: content,
                previewTextReview: content,
            };
            break;
        }
        case 'sequence': {
            const { start, leadingZeros, prefix, suffix, step = 1 } = types[
                activeType
            ].fields;

            const sequence = generatePreviewSequence(
                start,
                count,
                step,
                leadingZeros,
                prefix,
                suffix
            ).join(', ');
            const sequenceForReview = generatePreviewSequenceForReview(
                start,
                count,
                step,
                leadingZeros,
                prefix,
                suffix
            );

            layerData = {
                ...layerData,
                curve: getCurve(layer),
                // previewText: sequence,
                previewText: sequenceForReview,
                previewTextReview: sequenceForReview,
                sequenceCount: Number(count),
                types: {
                    ...layerData.types,
                    sequence: {
                        ...layerData.types.sequence,
                        fields: {
                            ...layerData.types.sequence.fields,
                            sequence: sequence,
                        },
                    },
                },
            };
            break;
        }
        case 'list': {
            const { content } = types[activeType].fields;
            const finalContent = getListLayerContent(content);

            layerData = {
                ...layerData,
                curve: getCurve(layer),
                previewText: content,
                previewTextReview: finalContent.join(', '),
                sequenceCount: finalContent.length,
            };
            break;
        }
        case 'image': {
            const { name } = types[activeType].fields;
            layerData = {
                ...layerData,
                curve: getCurve(layer),
                previewText: name,
                previewTextReview: name,
            };
            break;
        }
        case 'code': {
            const { name } = types[activeType];
            const {
                useSequence,
                content,
                start,
                leadingZeros,
                prefix,
                suffix,
                step = 1,
            } = types[activeType].fields;
            const finalContent = getListLayerContent(content);

            const listOfBarcodes = getAvailableBarcodes();
            const selectedBarcode = listOfBarcodes.find(
                (item) => item.value == barcode
            );

            // let previewText = name;
            let previewText = selectedBarcode ? selectedBarcode.label : barcode;
            let previewTextReview = selectedBarcode
                ? selectedBarcode.label
                : barcode;

            if (useSequence) {
                previewText += ' sequence';
                previewTextReview += ' sequence';

                const sequence = generatePreviewSequence(
                    start,
                    count,
                    step,
                    leadingZeros,
                    prefix,
                    suffix
                ).join(', ');
                const sequenceForReview = generatePreviewSequenceForReview(
                    start,
                    count,
                    step,
                    leadingZeros,
                    prefix,
                    suffix
                );

                // previewText += ` (${sequence})`;
                previewText += ` (${sequenceForReview})`;
                previewTextReview += ` (${sequenceForReview})`;
            } else {
                previewText += ` (${content})`;
                previewTextReview += ` (${content})`;
            }

            layerData = {
                ...layerData,
                previewText,
                previewTextReview: previewTextReview,
                sequenceCount: layerData.types.code.fields?.useList
                    ? finalContent.length
                    : count,
                curve: getCurve(layer),
                // types: {
                //     ...layerData.types,
                //     code: {
                //         ...layerData.types.code,
                //         fields: {
                //             ...layerData.types.code.fields,
                //             useList: false,
                //         },
                //     },
                // },
            };
            break;
        }
        case 'rfid': {
            const { content } = types[activeType].fields;
            layerData = {
                ...layerData,
                curve: getCurve(layer),
                previewText: content,
                previewTextReview: content,
            };
            break;
        }
    }
    return layerData;
};

/**
 * Get list layer field broken down content
 * @param content
 * @returns {*}
 */
export const getListLayerContent = (content) => {
    const contentList = content.split('\n').reduce((list, item) => {
        if (item) {
            const cleaned = item.trim();
            if (cleaned) {
                list.push(cleaned);
            }
        }

        return list;
    }, []);

    return contentList;
};

export const isHandleCorner = (handle) => {
    return (
        handle === 'topLeft' ||
        handle === 'topRight' ||
        handle === 'bottomLeft' ||
        handle === 'bottomRight'
    );
};

export const isBarcode = (layer) => {
    const { activeType, display, barcode } = layer;
    return activeType === 'code' && barcode;
    // return display === 1 && barcode;
};
export const isSquareBarcode = (layer) => {
    if (!isBarcode(layer)) return false;

    const squareBarcodes = [
        'datamatrix',
        'qrcode',
        'microqrcode',
        'hanxin',
        'azteccode',
    ];

    const { barcode } = layer;
    return squareBarcodes.includes(barcode);
};
export const isImage = (layer) => {
    const { activeType } = layer;
    return activeType === 'image';
};
export const isRFID = (layer) => {
    const { activeType } = layer;
    return activeType === 'rfid';
};
export const isAutoScaleTypeLayer = (layer) => {
    const { activeType, curve = false } = layer;
    return (
        !curve &&
        (activeType === 'text' ||
            activeType === 'sequence' ||
            activeType === 'list' ||
            activeType === 'rfid')
    );
};

// CANVAS
export const getBiggestLayerArea = (content, font) => {
    const arr = content.sort((a, b) => b.length - a.length).slice(0, 5); // get the 5 longest strings to test the drawing size
    const aux = arr.reduce((biggest, str) => {
        const strPath = font.getPath(str, 0, 0, 16);
        const strTemp = new PaperJS.CompoundPath(strPath.toPathData());
        const strRect = strTemp.bounds;
        strTemp.remove();
        if (!biggest || biggest.rect.width < strRect.width) {
            return {
                rect: strRect,
                text: str,
            };
        }
        return biggest;
    }, false);
    return aux;
};
export const getCanvasItem = (layer, target) => {
    if (!target) return false;
    return (
        target.getItem({
            match: (item) => item.data.id === layer,
        }) || false
    );
};
export const getShadowboundCanvasItem = (layer) => {
    return (
        layer.getItem({
            match: (item) => item.name === 'shadowbound',
        }) || false
    );
};
export const getTextCanvasItem = (layer) => {
    return (
        layer.getItem({
            match: (item) => item.name === 'text',
        }) || false
    );
};

// will remove these code for March 2020 Deliberable
export const togglehandleCorners = (project, opacity) => {
    const selectionLayer = getCanvasItem('selection', project);
    if (selectionLayer) {
        selectionLayer
            .getItems({
                recursive: false,
                match: (item) =>
                    item.data.type === 'handle' && isHandleCorner(item.name),
            })
            .map((item) => {
                item.opacity = opacity;
            });
    }
};

// FORM
export const validateForm = (fieldRefs) => {
    let values = [];

    // cycle fields refs
    Object.entries(fieldRefs).map(([name, field]) => {
        if (field !== null && field.props.required) {
            // radio/checkboxes
            if (field.props.checked !== undefined) {
                values.push(field.props.checked ? true : '');
            }
            // arrays
            else if (field.props.value instanceof Array) {
                values.push(field.props.value.length !== 0 ? true : '');
            }
            // default
            else {
                values.push(field.props.value);
            }
        }
    });
    if (!values.length) return false; // first load

    return values.some((value) => {
        return isEmpty(String(value));
    });
};

export const validateFormWithMessage = (fieldRefs) => {
    let fieldResponse = {};

    const defaultSuccessResponse = {
        status: true,
        message: '',
    };

    const defaultRequiredResponse = {
        status: false,
        message: 'This field is required',
    };

    // cycle fields refs
    Object.entries(fieldRefs).map(([name, field]) => {
        const fieldName = field.props.name;

        fieldResponse[fieldName] = { ...defaultSuccessResponse };

        if (field !== null && field.props.required) {
            // radio/checkboxes
            if (field.props.checked !== undefined && !field.props.checked) {
                fieldResponse[fieldName] = { ...defaultRequiredResponse };
            }
            // default
            else if (isEmpty(String(field.props.value))) {
                fieldResponse[fieldName] = { ...defaultRequiredResponse };
            }
        }
    });

    return fieldResponse;
};

export const getFieldStatusProps = (fieldStatus, fieldKey) => {
    let props = {};

    if (fieldStatus && fieldStatus[fieldKey] != undefined) {
        const fieldStatusData = fieldStatus[fieldKey];

        props = {
            ...props,
            forceDisplayError: !fieldStatusData.status,
            alertMessage: fieldStatusData.message,
        };
    }

    return props;
};

// Postman FORM
export const validatePostmanForm = (fieldRefs = {}) => {
    let values = [];

    if (Object.keys(fieldRefs).length === 0) {
        return true;
    }

    // cycle fields refs
    Object.entries(fieldRefs).map(([name, field]) => {
        if (field !== null && field.props.required) {
            if (field.props.value instanceof Array) {
                values.push(field.props.value.length !== 0 ? true : '');
            }
            // default
            else {
                values.push(field.props.value);
            }
        }
    });
    if (!values.length) return false; // first load

    return values.some((value) => {
        return isEmpty(String(value));
    });
};

export const checkIfCanToggleSides = (sides, target) => {
    let availableSides = 0;

    Object.values(sides).map((side) => {
        if (side.id !== target && side.active) {
            availableSides++;
        }
    });

    return availableSides > 0;
};

export const getAvailableBarcodes = () => {
    return [
        // {
        //     label: 'None',
        //     value: '',
        // },
        {
            label: 'Code 39',
            value: 'code39',
        },
        {
            label: 'Code 93',
            value: 'code93',
        },
        {
            label: 'GS1-128',
            value: 'gs1-128',
        },
        {
            label: 'Code 128',
            value: 'code128',
        },
        // {
        //     label: 'Code 128A',
        //     value: 'code128'
        // },
        // {
        //     label: 'Code 128B',
        //     value: 'code128'
        // },
        // {
        //     label: 'Code 128C',
        //     value: 'code128'
        // },
        // {
        //     label: 'Code 128 Optimized',
        //     value: 'code128'
        // },
        // {
        //     label: 'EAN-128A',
        //     value: 'gs1-128'
        // },
        // {
        //     label: 'EAN-128B',
        //     value: 'gs1-128'
        // },
        // {
        //     label: 'EAN-128C',
        //     value: 'gs1-128'
        // },
        {
            label: 'EAN-13',
            value: 'ean13',
        },
        // {
        //     label: 'EAN-13+2',
        //     value: 'ean13'
        // },
        // {
        //     label: 'EAN-13+5',
        //     value: 'ean13'
        // },
        {
            label: 'EAN-8',
            value: 'ean8',
        },
        // {
        //     label: 'EAN-8+2',
        //     value: 'ean8'
        // },
        // {
        //     label: 'EAN-8+5',
        //     value: 'ean8'
        // },
        {
            label: 'UPC-A',
            value: 'upca',
        },
        // {
        //     label: 'UPC-A+2',
        //     value: 'upca'
        // },
        // {
        //     label: 'UPC-A+5',
        //     value: 'upca'
        // },
        {
            label: 'UPC-E',
            value: 'upce',
        },
        // {
        //     label: 'UPC-E+2',
        //     value: 'upce'
        // },
        // {
        //     label: 'UPC-E+5',
        //     value: 'upce'
        // },
        {
            label: 'Code 25',
            value: 'code2of5',
        },
        {
            label: 'ITF 25',
            value: 'interleaved2of5',
        },
        {
            label: 'Codabar',
            value: 'rationalizedCodabar',
        },
        {
            label: 'PDF417',
            value: 'pdf417',
        },
        {
            label: 'Datamatrix',
            value: 'datamatrix',
        },
        {
            label: 'Datamatrix GS1',
            value: 'gs1datamatrix',
        },
        {
            label: 'QR Code',
            value: 'qrcode',
        },
        {
            label: 'Micro QR Code',
            value: 'microqrcode',
        },
        {
            label: 'Chinese Sensible Code',
            value: 'hanxin',
        },
        // {
        //     label: 'GM Code',
        //     value: 'gmcode'
        // },
        {
            label: 'Aztec Code',
            value: 'azteccode',
        },
    ];
};

export const getAvailableFontSizes = () => {
    if (isInGodMode() || true) {
        return [...Array(600).keys()].map((item) => {
            return {
                label: item + 1,
                value: item + 1,
            };
        });
    }

    return [
        {
            label: 16,
            value: 16,
        },
        {
            label: 24,
            value: 24,
        },
        {
            label: 32,
            value: 32,
        },
        {
            label: 40,
            value: 40,
        },
        {
            label: 48,
            value: 48,
        },
        {
            label: 56,
            value: 56,
        },
        {
            label: 64,
            value: 64,
        },
        {
            label: 72,
            value: 72,
        },
        {
            label: 80,
            value: 80,
        },
        {
            label: 88,
            value: 88,
        },
        {
            label: 96,
            value: 96,
        },
        {
            label: 104,
            value: 104,
        },
        {
            label: 112,
            value: 112,
        },
        {
            label: 120,
            value: 120,
        },
        {
            label: 128,
            value: 128,
        },
        {
            label: 136,
            value: 136,
        },
        {
            label: 144,
            value: 144,
        },
        {
            label: 152,
            value: 152,
        },
        {
            label: 160,
            value: 160,
        },
        {
            label: 168,
            value: 168,
        },
        {
            label: 176,
            value: 176,
        },
        {
            label: 184,
            value: 184,
        },
        {
            label: 192,
            value: 192,
        },
        {
            label: 200,
            value: 200,
        },
        {
            label: 208,
            value: 208,
        },
        {
            label: 216,
            value: 216,
        },
        {
            label: 224,
            value: 224,
        },
        {
            label: 232,
            value: 232,
        },
        {
            label: 240,
            value: 240,
        },
        {
            label: 248,
            value: 248,
        },
        {
            label: 256,
            value: 256,
        },
        {
            label: 264,
            value: 264,
        },
        {
            label: 272,
            value: 272,
        },
        {
            label: 280,
            value: 280,
        },
        {
            label: 288,
            value: 288,
        },
        {
            label: 296,
            value: 296,
        },
        {
            label: 304,
            value: 304,
        },
        {
            label: 312,
            value: 312,
        },
        {
            label: 320,
            value: 320,
        },
        {
            label: 328,
            value: 328,
        },
        {
            label: 336,
            value: 336,
        },
        {
            label: 344,
            value: 344,
        },
        {
            label: 352,
            value: 352,
        },
        {
            label: 360,
            value: 360,
        },
    ];
};

export const getAvailableFonts = () => {
    const fonts = [
        {
            value: '1',
            label: 'Noto Sans Regular',
            fontURL: 'NotoSans-Regular.woff'
        },
        {
            value: '2',
            label: 'Noto Sans Bold ',
            fontURL: 'NotoSans-Bold.woff'
        },
        // {
        //     value: '3',
        //     label: 'Source Han Light - Multilingual Support',
        //     fontURL: 'SourceHanSerifTC-Light.woff'
        // },
        // {
        //     value: '4',
        //     label: 'Source Han Bold - Multilingual Support',
        //     fontURL: 'SourceHanSerifTC-Bold.woff'
        // },
        {
            value: '3',
            label: 'Overpass Regular',
            fontURL: 'Overpass-Regular.woff',
        },
        {
            value: '4',
            label: 'Overpass Bold',
            fontURL: 'Overpass-Bold.woff',
        },
        {
            value: '5',
            label: 'PT Sans',
            fontURL: 'PTSans-Regular.woff',
        },
        {
            value: '6',
            label: 'Lora',
            fontURL: 'Lora-Medium.woff',
        },
        {
            value: '7',
            label: 'Raleway',
            fontURL: 'Raleway-Regular.woff',
        },
        {
            value: '8',
            label: 'Concert One',
            fontURL: 'ConcertOne-Regular.woff',
        },
        {
            value: '9',
            label: 'Prompt',
            fontURL: 'Prompt-Regular.woff',
        },
        {
            value: '10',
            label: 'Roboto',
            fontURL: 'Roboto-Regular.woff',
        },
        {
            value: '11',
            label: 'Merriweather',
            fontURL: 'Merriweather-Regular.woff',
        },
        {
            value: '12',
            label: 'Ubuntu',
            fontURL: 'Ubuntu-Regular.woff',
        },
        {
            value: '13',
            label: 'PT Serif',
            fontURL: 'PTSerif-Regular.woff',
        },
        {
            value: '14',
            label: 'Quicksand',
            fontURL: 'Quicksand-Regular.woff',
        },
        {
            value: '15',
            label: 'Libre Baskerville',
            fontURL: 'LibreBaskerville-Regular.woff',
        },
        {
            value: '16',
            label: 'Anton',
            fontURL: 'Anton-Regular.woff',
        },
        {
            value: '17',
            label: 'Amiri',
            fontURL: 'Amiri-Regular.woff',
        },
        {
            value: '18',
            label: 'Gotu',
            fontURL: 'Gotu-Regular.woff',
        },
        {
            value: '19',
            label: 'Permanent Marker',
            fontURL: 'PermanentMarker-Regular.woff',
        },
        {
            value: '20',
            label: 'Great Vibes',
            fontURL: 'GreatVibes-Regular.woff',
        },
        {
            value: '21',
            label: 'Kalam',
            fontURL: 'Kalam-Regular.woff',
        },
        {
            value: '22',
            label: 'Taviraj',
            fontURL: 'Taviraj-Regular.woff',
        },
        {
            value: '23',
            label: 'Neuton',
            fontURL: 'Neuton-Regular.woff',
        },
        {
            value: '24',
            label: 'Luckiest Guy',
            fontURL: 'LuckiestGuy-Regular.woff',
        },
        {
            value: '25',
            label: 'Pacifico',
            fontURL: 'Pacifico-Regular.woff',
        },
        {
            value: '26',
            label: 'Overpass Extra Bold',
            fontURL: 'Overpass-ExtraBold.woff',
        },
        {
            value: '27',
            label: 'Overpass Black',
            fontURL: 'Overpass-Black.woff',
        },
    ];

    return fonts.reduce((list, item) => {
        const { value, label, fontURL } = item;

        list[value] = {
            label,
            value,
            url: `${window.fontsURL}/${fontURL}`,
        };

        return list;
    }, {});
};
export const getGlyphsFromString = (font, text) => {
    let list = [];

    if(text != null && text != '') {
        text.split('').forEach(char => {
            const glyph = font.charToGlyph(char);
            if(glyph) {
                list.push(glyph);
            }
        })
    }

    return list;
};


// export const getGlyphsFromString = (font, text) => {
//     const list = [];

//     if (text && text.trim() !== '') {
//         text.split('').forEach(char => {
//             const glyph = font?.charToGlyph(char);

//             if (glyph) {
//                 list.push({
//                     name: glyph.name,
//                     unicode: glyph.unicode || char.codePointAt(0), 
//                     unicodes: glyph.unicodes || [char.codePointAt(0)], 
//                     advanceWidth: glyph.advanceWidth,
//                     index: glyph.index,
//                     yMin:glyph.yMin,
//                     leftSideBearing: glyph.leftSideBearing,
//                 });
//             } else if(glyph.name == '.notdef'){
//                 list.push({
//                     name: '.notdef', 
//                     unicode: char.codePointAt(0),
//                     unicodes: [char.codePointAt(0)], 
//                     advanceWidth: 0,
//                     index: -1,
//                     yMin:glyph.yMin,
//                     leftSideBearing: 0,
//                 });
//                 console.warn(`Glyph not found for character: ${char}`);
//             }
//         });
//     }

//     return list;
// };


